import { KeyValue } from "@/main/models/common";
import { ParameterFilterRequest } from "@/main/models/request/parameterFilterRequest";
import { ParameterTypesResponse } from "@/main/models/response/parameterTypesResponse";
import { ParameterActionTypes, ParameterTypes } from "./parameterTypes";

export function getParameters(request: ParameterFilterRequest): ParameterActionTypes {
	return {
		type: ParameterTypes.GET_PARAMETERS,
		payload: { request },
	};
}

export function saveParameters(
	data: ParameterTypesResponse[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): ParameterActionTypes {
	return {
		type: ParameterTypes.SAVE_PARAMETERS,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerParameters(): ParameterActionTypes {
	return {
		type: ParameterTypes.RESET_REDUCER_PARAMETERS,
	};
}

export function getParameterByTypeAndCompany(request: ParameterFilterRequest): ParameterActionTypes {
	return {
		type: ParameterTypes.GET_PARAMETER_BY_TYPE_AND_COMPANY,
		payload: { request },
	};
}

export function saveParameterByTypeAndCompany(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): ParameterActionTypes {
	return {
		type: ParameterTypes.SAVE_PARAMETER_BY_TYPE_AND_COMPANY,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerParameterByTypeAndCompany(): ParameterActionTypes {
	return {
		type: ParameterTypes.RESET_REDUCER_PARAMETER_BY_TYPE_AND_COMPANY,
	};
}
